export { default } from './PendingChangeAuthorDots';
